import generateCheckAvailDates from './generateCheckAvailDates'


const BCOM_SEARCH_URL = "https://www.booking.com/searchresults.html"

export const generateBcomLabel = ({type=''} = {}) => {
    let label = `&label=${encodeURIComponent(window.location.host)}`
    if (window.shared.options.page) label += `-${window.shared.options.page}`
    if (type) label += `-${type}`
    label += `-w${window.shared.options.log.wsl}`
    if(window.shared.options.pid) label += `-pid${window.shared.options.pid}`;

    return label
}

export const generateBcomSearchUrl = (searchParams={}, bcomParams={}) => {
    const bcomSearchParams = new URLSearchParams(searchParams)
    if (!searchParams.aid)
        bcomSearchParams.set('aid', shared.options.aid)

    const label = generateBcomLabel(bcomParams)

    const bcomSearchUrl = `${BCOM_SEARCH_URL}?${bcomSearchParams.toString()}${label}`

    return bcomSearchUrl
}

const generateBcomUrl = ({
    aid = shared.options.aid,
    destId = shared.options.dest_id,
    type = "",
    bid = shared.options.bid,
    destType = shared.options.dest_type || 'city',
    hash = "",
    dates = {}
}) => {

    if (!aid) throw new Error(`Click error. Required parameter 'aid' is not defined.`)
    if (!destId) console.error(`Click error. Required parameter 'destId' is not defined.`)
    if (!type) console.error(`Click error. Required parameter 'type' is not defined.`)

    let url = `https://www.booking.com/searchresults.html?dest_type=${destType}`
    url += `&dest_id=${destId}`

    url += `&aid=${aid}`

    if (bid)
        url += `&highlighted_hotels=${bid}`
    else
        if(shared.options.bc_f_u)
            url += `&${shared.options.bc_f_u}`

    const {checkIn, checkOut} = dates ? dates : generateCheckAvailDates();

    url += `&checkin=${checkIn}&checkout=${checkOut}`;

    url += `&selected_currency=`

    const label = generateBcomLabel({type})
    url += label

    if (hash) url += hash

    return url
}

export default generateBcomUrl
